/**
 * @generated SignedSource<<a4e403b380b587d8cc94753d1631ed0e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventAttendanceProgressBarFragment$data = {
  readonly eventOccurrences: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly datetimeRange: ReadonlyArray<string>;
        readonly id: string;
      };
    }>;
    readonly totalCount: number;
  } | null;
  readonly id: string;
  readonly occurrenceAttendances: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly occurrenceId: string;
      };
    }>;
  } | null;
  readonly " $fragmentType": "EventAttendanceProgressBarFragment";
};
export type EventAttendanceProgressBarFragment$key = {
  readonly " $data"?: EventAttendanceProgressBarFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventAttendanceProgressBarFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventAttendanceProgressBarFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "OccurrenceAttendanceNodeConnection",
      "kind": "LinkedField",
      "name": "occurrenceAttendances",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OccurrenceAttendanceNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "OccurrenceAttendance",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "occurrenceId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filterEventsToMembershipPeriod",
          "value": true
        }
      ],
      "concreteType": "OccurrenceNodeConnection",
      "kind": "LinkedField",
      "name": "eventOccurrences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "OccurrenceNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Occurrence",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "datetimeRange",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "eventOccurrences(filterEventsToMembershipPeriod:true)"
    }
  ],
  "type": "ProductMembership",
  "abstractKey": null
};
})();

(node as any).hash = "e1724738188168ef162d0ddf42546bd1";

export default node;
